import React, { Fragment } from "react"
import { Popover, Tooltip } from "antd"
import { get, filter, truncate, some } from "lodash"
import checkIcon from "../../images/check-measure.svg"
import ProgressBar from "../ProgressBar"
import noResponse from "../../images/no-response.svg"
import { LOCAL_COMPANY_NAME } from "../../utils/storage"

export const columns = (
  idStatus,
  onlyEnps,
  rowSelected,
  setStateFrom,
  checkIncludeSubdivisions,
  sortedInfo,
  filteredInfo,
  active_resend
) => {
  const contentResend = (
    <div style={{ maxWidth: 240 }}>
      No es posible hacer más de un 1 reenvío en un plazo de{" "}
      <strong>24 horas</strong>. La opción se habilitará nuevamente cuando el
      plazo haya transcurrido.
    </div>
  )

  const emptyValues = (text) => {
    return [{}, null, undefined, "", []].includes(text)
  }

  let sorted = sortedInfo || {}
  let filtered = filteredInfo || {}
  const dataColumns = [
    {
      title: "Divisiones",
      key: "division_name",
      dataIndex: "division_name",
      sorter: (a, b) => {
        const aDivision = a.name || ""
        const bDivision = b.name || ""

        return aDivision.localeCompare(bDivision)
      },
      sortOrder: sorted.columnKey === "division_name" && sorted.order,
      width: idStatus !== 5 ? 380 : 320,
      render: (_, record) => {
        if (record.document) {
          return (
            <div className="measurement-columns-name">
              <div>
                <span>
                  {record.survey_done ? (
                    <img src={checkIcon} />
                  ) : idStatus === 5 ? (
                    <img src={noResponse} />
                  ) : (
                    "•"
                  )}
                </span>
                {record.full_name}{" "}
                {record.email ? (
                  <Fragment>
                    - <span>{record.email} </span>
                  </Fragment>
                ) : (
                  ""
                )}
              </div>
              {/* <span>Líder</span> */}
            </div>
          )
        }

        return (
          <Tooltip title={record.division_name || record.name || "no name"}>
            {truncate(record.division_name || record.name || "no name", {
              length: 32,
            })}
          </Tooltip>
        )
      },
    },
    {
      title: "División Superior",
      key: "division_parent_name",
      dataIndex: "division_parent_name",
      sorter: (a, b) => {
        if (a.document || b.document) return

        const aDivisionParent = a.division_parent_name || ""
        const bDivisionParent = b.division_parent_name || ""

        return aDivisionParent.localeCompare(bDivisionParent)
      },
      sortOrder: sorted.columnKey === "division_parent_name" && sorted.order,
      width: 280,
      render: (_, record) => {
        if (record.document) return ""

        if (record.id_division === 1) {
          return (
            <strong style={{ textTransform: "uppercase" }}>
              {truncate(LOCAL_COMPANY_NAME(), { length: 32 })}
            </strong>
          )
        }

        return (
          <Tooltip title={record.division_parent_name || "no name"}>
            {truncate(record.division_parent_name, { length: 32 })}
          </Tooltip>
        )
      },
    },
    {
      title: "Colaboradores",
      width: 140,
      render: (_, record) => {
        if(record.hasOwnProperty("document")) {
          return
        }

        let totalResult = record.collaborators.length
        let answered = filter(
          record.collaborators,
          (item) => !!item.survey_done
        )

        let answeredResult = answered.length

        const recordRate = record.rate
        const recordRateSubDivision = record.rate_subdivision

        // eslint-disable-next-line
        if (
          !emptyValues(recordRate.rate_recipient_survey_done) &&
          checkIncludeSubdivisions
        ) {
          answeredResult = recordRate.rate_recipient_survey_done
          totalResult = recordRate.rate_recipient
        }

        // eslint-disable-next-line
        if (
          !emptyValues(recordRateSubDivision) &&
          !checkIncludeSubdivisions &&
          !emptyValues(recordRateSubDivision.rate_recipient_survey_done)
        ) {
          answeredResult = recordRateSubDivision.rate_recipient_survey_done
          totalResult = recordRateSubDivision.rate_recipient
        }

        return (
          <div>
            <span style={{ color: "#979797" }}>{answeredResult} / </span>
            {totalResult}
          </div>
        )
      },
    },
    {
      title: "Tasa de respuesta",
      key: "rate",
      width: 500,
      dataIndex: "rate",
      sorter: (a, b) => {
        if (a.document || b.document) return

        // orderBy by default
        let aResponse = get(a, "rate.rate", 0) || 0
        let bResponse = get(b, "rate.rate", 0) || 0

        // orderBy by Not IncludeSubdivisions
        // eslint-disable-next-line
        if (
          !emptyValues(a.rate.rate_recipient_survey_done) &&
          checkIncludeSubdivisions
        ) {
          aResponse = get(a, "rate.rate", 0) || 0
          bResponse = get(b, "rate.rate", 0) || 0
        }

        // orderBy by IncludeSubdivisions
        // eslint-disable-next-line
        if (
          !emptyValues(a.rate_subdivision) &&
          !checkIncludeSubdivisions &&
          !emptyValues(a.rate_subdivision.rate_recipient_survey_done)
        ) {
          aResponse = get(a, "rate_subdivision.rate", 0) || 0
          bResponse = get(b, "rate_subdivision.rate", 0) || 0
        }

        return parseInt(bResponse) - parseInt(aResponse)
      },
      sortOrder: sorted.columnKey === "rate" && sorted.order,
      filteredValue: filtered.rate || null,
      render: (_, record) => {
        if (
          record.document &&
          ![5].includes(idStatus) &&
          rowSelected.id_employee === record.id_employee
        ) {
          return (
            <div className="measurement-columns-response-rate__actions">
              {![2, 4].includes(idStatus) && record.email && (
                  record.active_resend ? (
                    <Popover content={contentResend} placement="topRight">
                      <span
                        className="color-blue hover-underline"
                        style={{
                          width: "60px",
                          marginRight: 15,
                          color: "rgba(0, 0, 0, 0.25)",
                          cursor: "no-drop",
                        }}>
                        {record.survey_done === 0 && "Reenviar"}
                      </span>
                    </Popover>
                  ) : (
                    <span
                      className="color-blue hover-underline"
                      style={{
                        width: "60px",
                        marginRight: 15,
                        color: "#378FEE",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setStateFrom({
                          modalResendSurvey: true,
                          resendSurveyTo: record,
                        })
                      }}>
                      {record.survey_done === 0 && "Reenviar"}
                    </span>
                  )
              )}
              <span
                className="color-red hover-underline"
                onClick={() => {
                  setStateFrom({
                    modalDeleteDivOrColl: true,
                    resendSurveyTo: record,
                  })
                }}>
                Eliminar
              </span>
            </div>
          )
        }

        if(record.hasOwnProperty("document")) {
          return
        }

        /* if (record.children && !record.children.length) {
          return <div style={{ paddingLeft: 16 }}>-</div>
        } */

        let color = get(record, "rate.rate_color", "")
        let value = get(record, "rate.rate", "")
        let value_visible = get(record, "rate.rate_visible", "")

        const recordRate = record.rate
        const recordRateSubDivision = record.rate_subdivision

        // eslint-disable-next-line
        if (
          !emptyValues(recordRate.rate_recipient_survey_done) &&
          checkIncludeSubdivisions
        ) {
          color = recordRate.rate_color
          value = recordRate.rate
          value_visible = recordRate.rate_visible
        }

        // eslint-disable-next-line
        if (
          !emptyValues(recordRateSubDivision) &&
          !checkIncludeSubdivisions &&
          !emptyValues(recordRateSubDivision.rate_recipient_survey_done)
        ) {
          color = recordRateSubDivision.rate_color
          value = recordRateSubDivision.rate
          value_visible = recordRateSubDivision.rate_visible
        }

        return (
          <div className="measurement-columns-response-rate">
            <ProgressBar
              // style={{ width: onlyEnps ? '100% !important' : '60% !important' }}
              custom={{
                color,
                value,
                value_visible,
              }}
            />

            {![5].includes(idStatus) &&
              rowSelected.id_division === record.id_division && (
                <div className="measurement-columns-response-rate__actions">
                  {record.hasOwnProperty("children") &&
                    ![2, 4].includes(idStatus) && (
                      <span
                        className="color-blue hover-underline"
                        style={{
                          width: "60px",
                          marginRight: 15,
                          color: record.active_resend
                            ? "rgba(0, 0, 0, 0.25)"
                            : "#378FEE",
                          cursor: record.active_resend ? "no-drop" : "pointer",
                        }}
                        onClick={() => {
                          if (!record.active_resend) {
                            setStateFrom({
                              modalResendSurvey: true,
                              resendSurveyTo: record,
                            })
                          }
                        }}>
                        {some(record.children, (item) => item.email) &&
                        record.active_resend ? (
                          <Popover content={contentResend} placement="topRight">
                            {record.rate.rate !== 100 && "Reenviar"}
                          </Popover>
                        ) : (
                          record.rate.rate !== 100 && "Reenviar"
                        )}
                      </span>
                    )}
                  {record.hasOwnProperty("children") && (
                    <span
                      className="color-red hover-underline"
                      onClick={() => {
                        setStateFrom({
                          modalDeleteDivOrColl: true,
                          resendSurveyTo: record,
                        })
                      }}>
                      Eliminar
                    </span>
                  )}
                </div>
              )}
          </div>
        )
      },
    },
  ]
  if (idStatus === 5) {
    dataColumns.push({
      title: "Resultado",
      key: "result",
      dataIndex: "result",
      width: idStatus !== 5 ? 260 : 200,
      render: (_, record) => {
        if (record.document || !record.result?.value_visible) {
          return <div className="cell-details-table-response" />
        }
        return (
          <div
            className="cell-details-table-response"
            style={{
              backgroundColor: get(
                record,
                "result.color",
                "rgb(227, 120, 121)"
              ),
            }}>
            {get(record, "result.value_visible", "0%")}
          </div>
        )
      },
    })
  }
  return dataColumns
}
